import React, { useState } from 'react';
import Card from '../../components/ui/Card';
import { CalendarIcon, DownloadIcon, ChevronLeftIcon, ChevronRightIcon, ClockIcon, PlayCircleIcon } from 'lucide-react';
const mockAggregators = [{
  id: 'agg1',
  name: 'Global Payments Network'
}, {
  id: 'agg2',
  name: 'Metro Financial Services'
}, {
  id: 'agg3',
  name: 'Digital Commerce Hub'
}, {
  id: 'agg4',
  name: 'PayTech Solutions'
}];
const mockMerchants = [{
  id: 'mer1',
  name: 'Global Electronics',
  aggregatorId: 'agg1'
}, {
  id: 'mer2',
  name: 'Fashion Boutique',
  aggregatorId: 'agg1'
}, {
  id: 'mer3',
  name: 'Tech Store',
  aggregatorId: 'agg2'
}, {
  id: 'mer4',
  name: 'Food Court',
  aggregatorId: 'agg2'
}, {
  id: 'mer5',
  name: 'Book Shop',
  aggregatorId: 'agg3'
}, {
  id: 'mer6',
  name: 'Sports Gear',
  aggregatorId: 'agg3'
}];
const generatePendingPayments = () => {
  const pending = [];
  mockMerchants.forEach(merchant => {
    const pendingCount = Math.floor(Math.random() * 20) + 1;
    const pendingAmount = (Math.random() * 10000 + 1000).toFixed(2);
    const oldestPending = new Date(2024, 0, Math.floor(Math.random() * 20) + 1);
    pending.push({
      merchantId: merchant.id,
      merchantName: merchant.name,
      aggregatorId: merchant.aggregatorId,
      pendingCount,
      pendingAmount: parseFloat(pendingAmount),
      oldestPendingDate: oldestPending.toISOString(),
      avgPendingDays: Math.floor(Math.random() * 10) + 1
    });
  });
  return pending;
};
const MerchantPendingPayments: React.FC = () => {
  const [fromDate, setFromDate] = useState(() => {
    const date = new Date();
    date.setDate(1);
    return date.toISOString().split('T')[0];
  });
  const [toDate, setToDate] = useState(() => new Date().toISOString().split('T')[0]);
  const [selectedAggregator, setSelectedAggregator] = useState('');
  const [selectedMerchant, setSelectedMerchant] = useState('');
  const [pendingPayments, setPendingPayments] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [reportGenerated, setReportGenerated] = useState(false);
  const itemsPerPage = 10;
  const filteredMerchants = selectedAggregator ? mockMerchants.filter(m => m.aggregatorId === selectedAggregator) : mockMerchants;
  const generateReport = () => {
    let pendingFiltered = generatePendingPayments();
    if (selectedAggregator) {
      pendingFiltered = pendingFiltered.filter(p => p.aggregatorId === selectedAggregator);
    }
    if (selectedMerchant) {
      pendingFiltered = pendingFiltered.filter(p => p.merchantId === selectedMerchant);
    }
    setPendingPayments(pendingFiltered);
    setCurrentPage(1);
    setReportGenerated(true);
  };
  const getCurrentPageData = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return pendingPayments.slice(startIndex, endIndex);
  };
  const getTotalPages = () => {
    return Math.ceil(pendingPayments.length / itemsPerPage);
  };
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-PK', {
      style: 'currency',
      currency: 'PKR',
      minimumFractionDigits: 2
    }).format(amount);
  };
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };
  const resetFilters = () => {
    const date = new Date();
    date.setDate(1);
    setFromDate(date.toISOString().split('T')[0]);
    setToDate(new Date().toISOString().split('T')[0]);
    setSelectedAggregator('');
    setSelectedMerchant('');
    setPendingPayments([]);
    setReportGenerated(false);
  };
  return <div className="space-y-6" data-id="element-5165">
      <div data-id="element-5166">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-5167">
          Merchant Pending Payments
        </h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-5168">
          View pending payment information grouped by merchants
        </p>
      </div>
      <Card data-id="element-5169">
        <div className="flex items-center justify-between mb-4" data-id="element-5170">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white" data-id="element-5171">
            Filters
          </h3>
          <button onClick={resetFilters} className="text-sm text-blue-600 dark:text-blue-400 hover:underline" data-id="element-5172">
            Reset Filters
          </button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-5173">
          <div data-id="element-5174">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-5175">
              From Date
            </label>
            <div className="relative" data-id="element-5176">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-5177">
                <CalendarIcon className="h-5 w-5 text-gray-400" data-id="element-5178" />
              </div>
              <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} className="w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800" data-id="element-5179" />
            </div>
          </div>
          <div data-id="element-5180">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-5181">
              To Date
            </label>
            <div className="relative" data-id="element-5182">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-5183">
                <CalendarIcon className="h-5 w-5 text-gray-400" data-id="element-5184" />
              </div>
              <input type="date" value={toDate} onChange={e => setToDate(e.target.value)} className="w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800" data-id="element-5185" />
            </div>
          </div>
          <div data-id="element-5186">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-5187">
              Aggregator
            </label>
            <select value={selectedAggregator} onChange={e => {
            setSelectedAggregator(e.target.value);
            setSelectedMerchant('');
          }} className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800" data-id="element-5188">
              <option value="" data-id="element-5189">All Aggregators</option>
              {mockAggregators.map(agg => <option key={agg.id} value={agg.id} data-id="element-5190">
                  {agg.name}
                </option>)}
            </select>
          </div>
          <div data-id="element-5191">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-5192">
              Merchant
            </label>
            <select value={selectedMerchant} onChange={e => setSelectedMerchant(e.target.value)} className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800" data-id="element-5193">
              <option value="" data-id="element-5194">All Merchants</option>
              {filteredMerchants.map(merchant => <option key={merchant.id} value={merchant.id} data-id="element-5195">
                  {merchant.name}
                </option>)}
            </select>
          </div>
        </div>
        <div className="mt-6 flex justify-end" data-id="element-5196">
          <button onClick={generateReport} className="inline-flex items-center px-6 py-2.5 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-5197">
            <PlayCircleIcon className="h-5 w-5 mr-2" data-id="element-5198" />
            Generate Report
          </button>
        </div>
      </Card>
      <Card data-id="element-5199">
        <div className="flex items-center justify-between mb-4" data-id="element-5200">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white" data-id="element-5201">
            Pending Payments
          </h3>
          {reportGenerated && pendingPayments.length > 0 && <button onClick={() => console.log('Export')} className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-5202">
              <DownloadIcon className="h-4 w-4 mr-2" data-id="element-5203" />
              Export
            </button>}
        </div>
        {!reportGenerated ? <div className="text-center py-12" data-id="element-5204">
            <ClockIcon className="mx-auto h-12 w-12 text-gray-400" data-id="element-5205" />
            <h3 className="mt-2 text-sm font-medium text-gray-900 dark:text-white" data-id="element-5206">
              No Report Generated
            </h3>
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-5207">
              Select your filters above and click "Generate Report" to view
              pending payments.
            </p>
          </div> : pendingPayments.length === 0 ? <div className="text-center py-12" data-id="element-5208">
            <ClockIcon className="mx-auto h-12 w-12 text-gray-400" data-id="element-5209" />
            <h3 className="mt-2 text-sm font-medium text-gray-900 dark:text-white" data-id="element-5210">
              No Pending Payments Found
            </h3>
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-5211">
              No pending payments match your selected filters. Try adjusting
              your criteria.
            </p>
          </div> : <>
            <div className="overflow-x-auto" data-id="element-5212">
              <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700" data-id="element-5213">
                <thead className="bg-gray-50 dark:bg-gray-700" data-id="element-5214">
                  <tr data-id="element-5215">
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase" data-id="element-5216">
                      Merchant
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase" data-id="element-5217">
                      Pending Count
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase" data-id="element-5218">
                      Pending Amount
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase" data-id="element-5219">
                      Oldest Pending
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase" data-id="element-5220">
                      Avg Pending Days
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700" data-id="element-5221">
                  {getCurrentPageData().map((pending: any) => <tr key={pending.merchantId} data-id="element-5222">
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white" data-id="element-5223">
                        {pending.merchantName}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-5224">
                        {pending.pendingCount}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-yellow-600 dark:text-yellow-400" data-id="element-5225">
                        {formatCurrency(pending.pendingAmount)}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-5226">
                        {formatDate(pending.oldestPendingDate)}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-5227">
                        {pending.avgPendingDays} days
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
            {getTotalPages() > 1 && <div className="flex items-center justify-between border-t border-gray-200 dark:border-gray-700 px-4 py-3 sm:px-6 mt-4" data-id="element-5228">
                <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between" data-id="element-5229">
                  <div data-id="element-5230">
                    <p className="text-sm text-gray-700 dark:text-gray-300" data-id="element-5231">
                      Showing{' '}
                      <span className="font-medium" data-id="element-5232">
                        {(currentPage - 1) * itemsPerPage + 1}
                      </span>{' '}
                      to{' '}
                      <span className="font-medium" data-id="element-5233">
                        {Math.min(currentPage * itemsPerPage, pendingPayments.length)}
                      </span>{' '}
                      of{' '}
                      <span className="font-medium" data-id="element-5234">
                        {pendingPayments.length}
                      </span>{' '}
                      results
                    </p>
                  </div>
                  <div data-id="element-5235">
                    <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" data-id="element-5236">
                      <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-sm font-medium text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50" data-id="element-5237">
                        <ChevronLeftIcon className="h-5 w-5" data-id="element-5238" />
                      </button>
                      {Array.from({
                  length: getTotalPages()
                }, (_, i) => i + 1).map(page => <button key={page} onClick={() => setCurrentPage(page)} className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${currentPage === page ? 'z-10 bg-blue-50 dark:bg-blue-900/30 border-blue-500 text-blue-600 dark:text-blue-400' : 'bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-600 text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'}`} data-id="element-5239">
                          {page}
                        </button>)}
                      <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, getTotalPages()))} disabled={currentPage === getTotalPages()} className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-sm font-medium text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50" data-id="element-5240">
                        <ChevronRightIcon className="h-5 w-5" data-id="element-5241" />
                      </button>
                    </nav>
                  </div>
                </div>
              </div>}
          </>}
      </Card>
    </div>;
};
export default MerchantPendingPayments;